import L from "leaflet";
import "leaflet-providers";
import "leaflet-pulse-icon";

/**
 * New7Wonders Events
 */
export default () => {
    $(document).ready(function () {

      // This watches for the scrollable container
      // eslint-disable-next-line no-unused-vars
        let scrollPosition = 0;

        $(window).scroll(function () {
            scrollPosition = $(this).scrollTop();
        });

        function initMap()
        {

          // This creates the Leaflet map with a generic start point, because code at bottom automatically fits bounds to all markers
            const map = L.map('story-map', {
                // maxBounds: L.latLngBounds([-200, -280], [200, 280]),
                sleep: false,
                center: [0, 0],
                zoom: 2,
                scrollWheelZoom: false,
                zoomControl: false,
            });

          // Base Map
            new L.tileLayer.provider('HERE.satelliteDay', {
                  // noWrap: false,
                app_id: 'KZ4MpfbVZ9Kd2CKzuzI7',
                app_code: 'qUwSrF9rG0HfNXxd1o977w',
            }).addTo(map);

          // This customizes link to view source code; add your own GitHub repository
            map.attributionControl
            .setPrefix('<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>');

          // TODO: We should not hide this. Let's find a better solution.
            $('.leaflet-control-attribution').hide();

          // Prepare Attay of all markers
            let layers = [];

          // This loads the needed values from dom and prepares the markers
            $('.event-container').each(function () {

                const containerID = $(this).data('id');
                const lat = $(this).data('lat');
                const long = $(this).data('long');
                const zoom = $(this).data('zoom');

                // Build array of all Markers
                layers.push([lat, long]);

                // console.log( containerID + '. ' + lat + ', ' + long );

                // This creates numerical icons to match the ID numbers
                let numericMarker = L.icon.pulse({
                    iconSize: [20, 20],
                    color: '#fff',
                    animate: true,
                    heartbeat: 40,
                });


                let layer = L.marker([lat, long], {icon: numericMarker});
                layer.addTo(map);


                let playlistHeight = $('#events_playlist').height() + $('#space-at-the-top').height() * 2;
                let i;
                let areaTop = playlistHeight;
                let areaBottom = 0;

                // Calculating total height of blocks above active
                for (i = 1; i < containerID; i++) {
                    areaTop += $('div.container' + i).height();
                }

                //console.log( areaTop );

                areaBottom = areaTop + $('div.container' + containerID).height();

                $(window).scroll(function () {

                    if ($(this).scrollTop() >= areaTop && $(this).scrollTop() < areaBottom) {
                        let currentContainer = $('div.container' + containerID);

                        currentContainer.addClass("inFocus").removeClass("outFocus");

                        map.flyTo([lat, long], zoom);
                        $(layer._icon).addClass('pulsing');
                    } else {
                        $(layer._icon).removeClass('pulsing');
                    }
                });

                // Make markers clickable
                layer.on('click', function () {
                    $("html, body").animate({scrollTop: areaTop + "px"});
                });

                $('.container1').addClass("inFocus");

            });

          // var polyLine = new L.Polyline(layers, {color: 'white'}).addTo(map);

            let bounds = L.latLngBounds(layers);

            map.fitBounds([
              bounds.pad(0.1),
            ]);

        }


        initMap();

    });
};
